<template>
    <u-file-input-outlined-tile v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-file-input-outlined-tile>
</template>

<script>
import UFileInputOutlinedTile from "@/components/publish/styles/forms/u-file-input-outlined-tile.vue";

export default {
    props: {},
    components: {
        UFileInputOutlinedTile,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
